import React from 'react'
import { GREEN, BRIGHT_GREEN } from '@omnilert/components'

const Check = ({ strokeColor }) => {
  return (
    <svg
      fill='none'
      height='162'
      viewBox='0 0 162 162'
      width='162'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M119.769 48.686l-45.23 61.384L42.23 84.224'
        stroke={strokeColor || 'url(#paintgreen0_linear)'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='6.462'
      />
      <path
        d='M81 155.301c41.039 0 74.308-33.269 74.308-74.307 0-41.04-33.269-74.308-74.308-74.308-41.039 0-74.308 33.269-74.308 74.308C6.692 122.031 39.961 155.3 81 155.3z'
        stroke={strokeColor || 'url(#paintgreen1_linear)'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='12.923'
      />
      <defs>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paintgreen0_linear'
          x1='47.813'
          x2='119.769'
          y1='79.378'
          y2='79.378'
        >
          <stop stopColor={BRIGHT_GREEN} />
          <stop
            offset='1'
            stopColor={GREEN}
          />
        </linearGradient>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paintgreen1_linear'
          x1='17.393'
          x2='155.308'
          y1='80.993'
          y2='80.993'
        >
          <stop stopColor={BRIGHT_GREEN} />
          <stop
            offset='1'
            stopColor={GREEN}
          />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Check
